import type { IconData } from '@stacksjs/iconify-core'

export const natureLeaf: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 7a7 7 0 0 1-10.848 5.848L2 16l-2-2l7-7l-1.06-1.06l-3.503 3.5A7 7 0 0 1 9 0h7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureLeaf
